import {
	Button,
	Dialog,
	DialogBody,
	DialogHeader,
	Input,
	Option,
	Select,
	Textarea
} from '@material-tailwind/react';
import _ from 'lodash';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { SocketRPC, socketEmit } from '../../lib/socket';
import useUser from '../../store/user';


const SubmitOrderDisputeModal = ({ order, submitDisputeModalOpen, toggleOpen, onSubmitCompleted = () => {} }) => {
	const [loading, setLoading] = useState(false);
	const [disputeReason, setDisputeReason] = useState<string | undefined>(undefined);
	const [requestedRefundAmount, setRequestedRefundAmount] = useState<number | null>(null);
	const [disputeDescription, setDisputeDescription] = useState('');
    const { user } = useUser();
	const orderSubtotal = _.get(order, 'price.subTotal');

	const mode = 'dispute';

	const onSubmitOrderDispute = async () => {
		if (!requestedRefundAmount || !disputeReason) {
			toast.error('Please ensure all fields are filled out.');
			return;
		}

		const body = {
			orderKey: order.orderKey,
			disputeReason,
			requestedRefundAmount,
			disputeDescription,
            requestUser: user?.userKey,
			user,
		};

		setLoading(true);
		socketEmit(SocketRPC.TrySubmitOrderDispute, body)
			.then((res) => {
				if (!res.success) {
					throw new Error(res.error);
				}
				toast.success('Order dispute submitted successfully!');
				toggleOpen();
			})
			.catch((err) => {
				toggleOpen();
				toast.error(`Failed to submit order dispute`);
			})
			.finally(() => {
				onSubmitCompleted();
				setLoading(false);
			});
	};

	return (
		<Dialog open={submitDisputeModalOpen} handler={toggleOpen}>
			<DialogHeader>
				{mode === 'dispute' ? `Submit a dispute` : `Submit an appeal`}
			</DialogHeader>
			<DialogBody divider>
				<div className="flex flex-col gap-y-3">
					<div>
						<Select
							label="Dispute Reason"
							placeholder="Select Dispute Reason"
							selected={(element) => { // material-tailwind onChange for select was not working for some reason
								element &&
									setDisputeReason(element.props.value);
								return element;
							}}
						>
							<Option value='LATE ORDER'>Late Order</Option>
							<Option value='ORDER NOT RECEIVED'>Customer did not receive order</Option>
							<Option value='DAMAGED ITEMS'>Damaged order</Option>
							<Option value='MISSING ITEMS'>Missing items</Option>
							<Option value='OTHER'>Other</Option>
						</Select>
					</div>
					{disputeReason && (
						<>
							<div className="py-6 flex gap-x-6 px-2 justify-center items-center">
								<div>
									<input
										type="range"
										value={requestedRefundAmount || 0}
										onChange={(e) =>
											setRequestedRefundAmount(
												Number(e.target.value)
											)
										}
										max={orderSubtotal}
										min={0}
										step={0.01}
									/>
								</div>
								<Input
									crossOrigin=""
									type="number"
									label="Requested Refund Amount ($)"
									value={requestedRefundAmount || 0}
									onChange={(e) =>
										setRequestedRefundAmount(
											Number(e.target.value)
										)
									}
									max={orderSubtotal}
									min={0}
									step={0.01}
									size="md"
								/>
								<Input
									crossOrigin=""
									type="text"
									label="% of Order Subtotal"
									value={`${(((requestedRefundAmount || 0)/orderSubtotal) * 100).toFixed(1)}%`}
									className='pointer-events-none'
									size="md"
								/>
							</div>
							<div>
								<Textarea
									size="lg"
									label="Dispute Description: explain the reason for this dispute in as much detail as possible."
									onChange={(e) =>
										setDisputeDescription(e.target.value)
									}
									maxLength={250}
								></Textarea>
							</div>
						</>
					)}
					<Button
						className="w-full bg-blue-600 hover:bg-blue-400 text-white"
						onClick={onSubmitOrderDispute}
					>
						{loading ? 'Loading' : `Submit`}
					</Button>
				</div>
			</DialogBody>
		</Dialog>
	);
};

export default SubmitOrderDisputeModal;
